import React, { useContext, useEffect, useState } from 'react'
import { CommentHeader, CommentItem, CommentList, CommentText, HistoryItemText, Section, SectionTitle, InputComment, UserImage, WhatTime, InputCommentDiv } from '../style'
import { MessageSquareMore, User } from 'lucide-react'
import axios from '../../../../config/axios'
import UserContext from '../../../../contexts/UserContext'

const CommentsOfOp:React.FC<{ticketId:number}> = ({ticketId}) => {
  const [ comments, setComments ] = useState<{id:number, comment:string, createdAt:string, createdBy?: {id:number, name:string, picture?:string}}[]>([])
  const [ comment, setComment ] = useState<string>('')
  const { user } = useContext(UserContext)

  const resolveUserPicture = (userLike: any): string | undefined => {
    return userLike?.picture || userLike?.avatar || userLike?.avatarUrl || userLike?.profilePicture || userLike?.image || userLike?.photo || undefined
  }

  const normalizeComment = (rawComment: any) => {
    const sourceUser = rawComment?.createdBy || rawComment?.User || rawComment?.user || null
    const normalizedUser = sourceUser
      ? {
          id: sourceUser.id,
          name: sourceUser.name,
          picture: resolveUserPicture(sourceUser)
        }
      : undefined

    return {
      id: rawComment?.id,
      comment: rawComment?.comment,
      createdAt: rawComment?.createdAt,
      createdBy: normalizedUser
    }
  }

  const fetchComments = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/pipelines/comments`,{
        params: {
          ticketId: ticketId
        }
      })
      if(response.data) {
        const data = Array.isArray(response.data?.data) ? response.data.data : []
        setComments(data.map((item: any) => normalizeComment(item)))
      }
    } catch(error) {
      console.error(error)
    }
  }

  useEffect(() => {
    fetchComments()
  }, [ticketId])

  const handleAddComment = async () => {
    if (!comment.trim()) {
      return
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/pipelines/comments`, {
        comment: comment,
        ticketId: ticketId
      })
      if(response.data) {
        setComment('')
        await fetchComments()
      }
    }
    catch(error) {
      console.error(error)
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if(e.key === 'Enter') {
      handleAddComment()
    }
  }
  
  return (
    <>
      <SectionTitle>Comentários</SectionTitle>
      <CommentList>
        <InputCommentDiv>
          <UserImage biggest={true}>{resolveUserPicture(user) ? <img src={resolveUserPicture(user)} alt={user.name} style={{width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover'}} /> : <User size={20} />}</UserImage>
          <InputComment
            placeholder='Escreva um comentário...'
            onKeyDown={handleKeyDown}
            onChange={(e) => setComment(e.target.value)}
            value={comment}
          />
        </InputCommentDiv>
        {comments.map((comment) => (
          <CommentItem key={comment.id}>
            <CommentHeader>
              <UserImage>{resolveUserPicture(comment.createdBy) ? <img src={resolveUserPicture(comment.createdBy)} alt={comment.createdBy?.name} style={{width: '20px', height: '20px', borderRadius: '50%', objectFit: 'cover'}} /> : <User size={20} />}</UserImage>
              <HistoryItemText><span>{comment.createdBy?.name}</span></HistoryItemText>
            </CommentHeader>
            <CommentText>{comment.comment}</CommentText>
            <WhatTime>{new Date(comment.createdAt).toLocaleString()}</WhatTime>
          </CommentItem>
        ))}
      </CommentList>
    </>
  )
}

export default CommentsOfOp